import React from 'react';
import { Link } from 'react-router-dom';
import { IconMail, IconMapPin } from '@tabler/icons-react';
import { DateTime } from 'luxon';

const Footer = () => {
  const currentYear = DateTime.now().year;

  return (
    <footer className="ub-footer">
      <div className="ub-footer-container">
        <section className="ub-footer-main">
          <div className="ub-footer-brand">
            <img
              src="/whiteUbsportsLogo.png"
              alt="UBsports Logo"
              className="ub-footer-logo"
            />
            <p className="ub-footer-tagline">
              Your ultimate destination for sports, leagues, and community
            </p>
          </div>

          <div className="ub-footer-links">
            <div className="ub-footer-column">
              <h3 className="ub-footer-title">Platform</h3>
              <Link to="/" className="ub-footer-link">Home</Link>
              <Link to="/sports/pickleball" className="ub-footer-link">Sports</Link>
              <Link to="/leagues" className="ub-footer-link">Leagues</Link>
              <Link to="/videos" className="ub-footer-link">Videos</Link>
              <Link to="/shop" className="ub-footer-link">Shop</Link>
            </div>

            <div className="ub-footer-column">
              <h3 className="ub-footer-title">For Athletes</h3>
              <Link to="/ubunited" className="ub-footer-link">UBUnited</Link>
              <Link to="/leagues" className="ub-footer-link">Join a League</Link>
            </div>

            <div className="ub-footer-column">
              <h3 className="ub-footer-title">Company</h3>
              <a href="#" className="ub-footer-link">About Us</a>
              <a href="#" className="ub-footer-link">Partners</a>
            </div>

            <div className="ub-footer-column">
              <h3 className="ub-footer-title">Contact</h3>
              <a href="mailto:support@ubsports.com" className="ub-footer-contact">
                <IconMail size={18} stroke={2} />
                <span>support@ubsports.com</span>
              </a>
              <div className="ub-footer-contact">
                <IconMapPin size={18} stroke={2} />
                <span>New York City</span>
              </div>
            </div>
          </div>
        </section>

        <section className="ub-footer-bottom">
          <div className="ub-footer-legal">
            <p className="ub-footer-copyright">
              &copy; {currentYear} UBsports, Inc. All rights reserved.
            </p>
            <div className="ub-footer-legal-links">
              <a href="#" className="ub-legal-link">Privacy Policy</a>
              <a href="#" className="ub-legal-link">Terms of Service</a>
              <a href="#" className="ub-legal-link">Cookie Policy</a>
            </div>
          </div>
        </section>
      </div>
    </footer>
  );
};

export default Footer;
